export default "https://static.zego.com/_next/static/chunks/fonts/ModernEra-Regular-26189afd6c02dd6a58e6fbe1ab99f27c.woff";